export default "__VITE_ASSET__AW$raTxT__"